module.exports = __webpack_public_path__ + "901d8e768b29865e0cc81be6c33b2328.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/16-Betsolutions-Night-Life.png
// module id = 1738
// module chunks = 2